import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import AuthorUserLink from '../AuthorUserLink';
import CommentTimestamp from '../CommentTimestamp';
import FeaturedTag from '../FeaturedTag';
import s from './BylineBlock.scss';
/**
 * A user link, a timestamp, and a "Featured" tag if the comment is featured.
 *
 * We tend to add this just before the text content of a comment.
 * */ const BylineBlock = ({ className })=>{
    const { comment } = useContext(CommentContext);
    const { isFeatured, user } = comment;
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, user && /*#__PURE__*/ React.createElement(AuthorUserLink, {
        comment: comment,
        className: s['userlink']
    }), /*#__PURE__*/ React.createElement(CommentTimestamp, {
        className: s['timestamp']
    }), isFeatured && /*#__PURE__*/ React.createElement(FeaturedTag, null));
};
BylineBlock.displayName = 'BylineBlock';
export default BylineBlock;
